<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="observationName + ' [Observations] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/observations`">
                            <i class="fa fa-comment-o"></i> Observations
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        {{ observationName }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8">
                    <div class="card mb-3">
                        <div class="card-header">
                            Observation: <strong>{{ observation.SectionOrder }}.{{ observation.ElementOrder }} {{ observation.ElementText }}</strong>
                            <div class="float-sm-right float-none d-print-none d-block d-sm-inline-block mt-2 mt-sm-0" v-if="canEdit">
                                <router-link :to="`/observations/edit/${observation.observation_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/observations/delete/${observation.observation_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">Inspection Form:</div>
                                <div class="col-md-9">
                                    <router-link :to="`/inspections/forms/${observation.inspection_form_id}`">{{ observation.form_name }}</router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">Inspection Section:</div>
                                <div class="col-md-9">{{ observation.SectionOrder }}. {{ observation.SectionName }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">Inspection Element:</div>
                                <div class="col-md-9">{{ observation.SectionOrder }}.{{ observation.ElementOrder }} {{ observation.ElementText }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">Observation Date:</div>
                                <div class="col-md-9">{{ observation.observation_date | moment("MM/DD/YYYY") }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">User:</div>
                                <div class="col-md-9"><user-name :user="observation" /></div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">Jobsite:</div>
                                <div class="col-md-9">
                                    <router-link :to="`/jobsites/view/${observation.jobsite_id}`">
                                        {{ observation.JobsiteNumber }} - {{ observation.JobsiteName }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="observation.subcontractor_id">
                                <div class="col text-muted text-md-right">Subcontractor:</div>
                                <div class="col-md-9">
                                    <router-link :to="`/subcontractors/view/${observation.subcontractor_id}`">
                                        {{ observation.subcontractor_name }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">
                                    Compliance:
                                </div>
                                <div class="col-md-9">
                                    <label class="badge badge-success" v-if="observation.compliance_status_id === 1">Compliant</label>
                                    <label class="badge badge-danger" v-else>Non-Compliant</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted text-md-right">
                                    Status:
                                </div>
                                <div class="col-md-9">
                                    <label :class="`badge badge-${observation.status_color}`">{{ observation.status_name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="observation.compliance_status_id === 1">
                        <div class="card mb-3" v-if="observation.comments">
                            <div class="card-header"><strong>Compliant Comments</strong></div>
                            <div class="card-body">
                                <div v-html="observation.comments"></div>
                            </div>
                        </div>
                        <div class="card mb-3" v-if="files.length > 0">
                            <div class="card-header"><strong>Files/Photos ({{ files.length }})</strong></div>
                            <div class="card-body">
                                <file-list :files="files" />
                            </div>
                        </div>
                    </template>
                    <div class="card mb-3" v-else>
                        <div class="card-header"><strong>Corrective Action</strong></div>
                        <div class="card-body">
                            <corrective-action-table-list :actions="[action]" view="cards"></corrective-action-table-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                observation_id: this.$route.params.id,
                observation: {},
                action: {},
                files: [],
            }
        },

        computed: {
            observationName(){
                //Build the date
                var date = moment(this.observation.observation_date, 'YYYY-MM-DD').format('MM/DD/YYYY');

                //Send it
                return date + '-' + this.observation.FirstName + '-' + this.observation.LastName+'-JOB#' + this.observation.JobsiteNumber;
            },

            canEdit(){
                //Check manager permission
                if(this.$root.hasPermission('inspections.manage'))
                {
                    return true;
                }

                //Check manager permission
                if(this.$root.hasPermission('inspections.create') && this.observation.user_id == this.$store.state.user.user_id)
                {
                    return true;
                }

                //Default
                return false;
            },
        },

        methods: {

            getObservation() {
                //Get the data
                this.$http
                    .get('observations/view/' + this.observation_id)
                    .then(response => {
                        //Set all the data
                        this.observation = response.data.observation;
                        this.action = this.observation.action;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the HSE
            this.getObservation();
        }
    }
</script>
